import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { IIncentiveSetting } from "./Form";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface IProps {
    setModal: (modal: { open: boolean, singleData: IIncentiveSetting }) => void,
    reload: boolean,
    toast: any,
}

const EmptyIncentive: IIncentiveSetting = {
    months: 0,
};

export const Table = (props: IProps) => {
    const [date, setDate] = useState<any>([]);
    const [activeIndex, setActiveIndex] = useState<number | number[]>();

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyIncentive });
    };

    const leftToolbarTemplate = () => {
        return <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => openNew()} />;
    };

    const loadTableData = async () => {
        const response = await Fetch("Website_Settings/getIncentiveSetting", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setDate(data);
        }
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
                <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
                    <AccordionTab header="No of months back Paid Invoice Incentive To Be Calculated">
                        <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                            size="small"
                                value={[date]}
                                    emptyMessage="No Data found.">
                                <Column field="months" header="Months" />
                            <Column field="inc_Cal_Day" header="user Incentive Calculation Day" />
                            <Column field="branch_Inc_Cal_Day" header="Branch Incentive Calculation Day" />
                        <Column field="" header="Action" body={(rowData: any) => <p className="pi pi-pencil text-primary" style={{ cursor: "pointer" }} onClick={() => props.setModal({ singleData: rowData, open: true })}></p>} />
                    </DataTable>
                </AccordionTab>
            </Accordion>
        </>
    );
}